module.exports = __webpack_public_path__ + "media/images/athletes/3542-ddba2d23728438032c3353ad7ea04f0e.png";